import alt from '../alt';

class LocaleActions {
	setLocale(lang) {
		return lang;
	}
}

export default alt.createActions(LocaleActions);
